export default __webpack_public_path__ + "static/media/epsaNewEn.c4c89c9a.png";